export default (state = null, action) => {
  if (action.type === "SET_RESULT") {
    return action.result;
  } else if (action.type === "START_SUBMIT") {
    return null;
  }

  return state;
};
